import { apiUrl } from '@sm/config';
import { REPORT_TYPES } from '@modules/generateReport/GenerateReport';

export const menuList = [{
  id: 'home',
  name: 'Methods',
  url: '/dashboard',
  access: 'DASHBOARD'
}, {
  id: 'article',
  name: 'Reports',
  url: '/generate-reports',
  report: REPORT_TYPES.TRANSACTIONS,
  access: 'REPORTS'
}, {
  id: 'folder_code',
  name: "Api Docs",
  url: apiUrl,
  access: 'API'
}, {
  id: 'encrypted',
  name: 'Bank Codes',
  url: '/bank-codes',
  access: 'BANKLIST'
}];
